export default function CheckThick({ size = 20, className = '' }) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.6666 5L7.49992 14.1667L3.33325 10"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  );
}
